import { render, staticRenderFns } from "./students-attends-print.vue?vue&type=template&id=ef65a620&"
import script from "./students-attends-print.vue?vue&type=script&lang=js&"
export * from "./students-attends-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports